import React from 'react';

import './TableHeader.sass';

const TableHeader = () => {
  return (
    <div className="name-titles row">
      <div className="col-2 title justify-content-center d-flex">
        Краткое наименование
      </div>
      <div className="col-8 title">
        Наименование
      </div>
      <div className="col-2 col-xl-2 title justify-content-center d-flex">
        Удалить
      </div>
    </div>
  );
};

export default TableHeader;